import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const currentUserEntitiy = state => state.entities.userDetails;
const userEntity = state => state.entities.user;
const currentUserId = state => state.currentUser.id;

export const currentUserSelector = createSelector([currentUserEntitiy, userEntity, currentUserId], (entity, user, id) => {
  let data = entity[id];
  console.log("Selecter data 1", data);
  console.log("Select ID", id);
  if (isEmpty(data)) {
    return data;
  }
  console.log("Selecter entity", entity);
  console.log("Selecter user", user);
  data = { ...data, user: entity[id].user };
  console.log("Selecter data 2", data);
  return data;
});

export default currentUserSelector;
